import { useEffect, useState } from 'react'

import { useAppSelector } from 'src/Hooks/redux'
import { getIsAuth } from 'src/Redux/auth-process/credentialsSlice/selectors'
import { getScVidFromSearch, persistPendingScVid } from 'src/Utils/pendingScVid'

export const useCaptureScVid = (): null => {
  const isAuth = useAppSelector(getIsAuth)
  const [scVidOnLoad] = useState(() =>
    getScVidFromSearch(window.location.search),
  )
  const [isAuthOnLoad] = useState(isAuth)

  useEffect(() => {
    if (scVidOnLoad && !isAuthOnLoad) {
      persistPendingScVid(scVidOnLoad)
    }
  }, [scVidOnLoad, isAuthOnLoad])

  return null
}
